<template>
  <NxInput
    name="nome"
    type="text"
    label="Número do Protocolo:"
    placeholder="Digite o Número do Protocolo"
    @update:value="handleValueUpdate"
    :value="displayValue"
  ></NxInput>
</template>

<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxInputProtocolsWApp',
  mixins: [useReactiveModelMixin('value')],
  data () {
    return {
      localValue: ''
    }
  },
  computed: {
    displayValue () {
      return this.localValue
    }
  },
  methods: {
    handleValueUpdate (val) {
      if (val) {
        this.localValue = val
        this.$emit('update:value', val)
      } else {
        this.localValue = null
        this.$emit('update:value', null)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-inputs/NxInputProtocolsWApp.vue